<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="a__gjdgxs"><span>Season to Shimmer</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Kim Katil</p>
<p class="P_Normal"> </p>
<p class="P_Normal">One morning close to the holidays, Nolan wakes up to two surprises: a distress call from his younger brother and a beautiful man in his bed. Nolan, an art gallery owner, has always been discreet about his sexuality, but when his baby brother plans to come out at the annual family gala, Nolan wants to have his back—and that means showing up with a man of his own on his arm. Nolan knows just the man for the job.</p>
<p class="P_Normal">Skylar, who owns a karate studio in St. Augustine, can’t get his one-night stand out of his mind. When he runs into Nolan at his gallery he is more than happy to volunteer his services as arm candy. Out-and-proud himself with his striking blue/green hair, Skylar is all in. Their adventure means a fancy salon, family drama, lots of sex, a ninja hippo, and palm trees lit up in a very suggestive way. By the end of it, what started as a hookup might become much more.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?75b0b8dc